/* eslint-disable react/jsx-no-comment-textnodes */
import type { ReactNode, ReactElement } from 'react';

import { forwardRef } from 'react';
import type { ForwardedRef } from 'react';
// material
import { Avatar } from '@mui/material';

export interface MAvatarProps {
  children?: ReactNode;
  sx?: Record<string, any>;
  color?: Record<string, any>;
  [key: string]: any;
}

// ----------------------------------------------------------------------

const MAvatar = forwardRef(function MAvatarImpl(
  { color, sx, children, ...other }: MAvatarProps,
  ref: ForwardedRef<HTMLElement>
) {
  const baseStyles = {
    fontWeight: 700,
    fontSize: '0.85rem',
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  };

  return (
    // @ts-ignore legacy boundary
    <Avatar
      ref={ref}
      sx={{
        ...baseStyles,
        ...(color?.bg && {
          backgroundColor: color.bg,
          color: color.text,
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Avatar>
  );
});

export default MAvatar;
